/* eslint-disable no-template-curly-in-string, sonarjs/no-nested-template-literals, sonarjs/cognitive-complexity, no-param-reassign, camelcase, prefer-destructuring, no-shadow, prefer-const, no-console, no-unused-vars, prefer-template, no-nested-ternary, react/no-danger */
/* eslint-disable react/jsx-filename-extension, sonarjs/no-duplicate-string, react/no-unused-state, react/prop-types, react/destructuring-assignment, react/no-access-state-in-setstate */
import React, { Component, createRef } from "react";
import { Card, Row, Col, Button, Form, Dropdown } from "react-bootstrap";
import { Chart } from "react-google-charts";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../Loader/Loader";
import { exportAuditMiningPDF, getAuditDataMining, exportAuditMiningXLS } from "../../Actions/SuperAdminAction/actions";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import PropertDetails from "../LandingPage/PropertySelection";
import { SuperAdminAction } from "../../Actions";

const ALL_CHILD_DOMAIN = "-Show each property-";
const COMBINE_METER = "-Combine Together-";
const OUTPUT_OPTIONS = [
  { label: "Data Table", value: "table" },
  { label: "Bar Chart", value: "bar_chart" },
  { label: "Stacked Bar Chart", value: "stacked_bar_chart" },
  { label: "Area Chart", value: "area_chart" },
  { label: "Stacked Area Chart", value: "stacked_area_chart" },
  { label: "Pie Chart", value: "pie_chart" },
];
const DEFAULT_CHART_DATA = [
  ["Date", "Mastercard", "Visa", "Cash"],
  ["No Data", 0, 0, 0],
];

// Used to get the simple option button appearence on chart pages
const CustomToggle = React.forwardRef(({ onClick }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    role="button"
    aria-label="More options"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick(e);
      }
    }}
    className="btn btn-sm border-0 bg-light w-30px h-30px d-flex align-items-center justify-content-center"
  >
    <i className="fa fa-ellipsis-v" />
  </div>
));
CustomToggle.displayName = "CustomToggle";

const INITIAL_FILTERS = {
  includeChildren: true,
  key: "dev-key",
  child_domain: ALL_CHILD_DOMAIN,
  meter: COMBINE_METER,
  time_resolution: "Day",
  type: "Paid and Refunds",
  show: ["Value"],
  payment_method: "Detailed",
  display_as: "Value",
  from_date: moment().subtract(29, "days").format("YYYY-MM-DD"),
  to_date: moment().format("YYYY-MM-DD"),
  output: "table",
  selectedProperty: "",
  selectedPropertyObj: {},
  childcheckbox: true,
  all_properties: [],
};

class AdvancedRevenueReportData extends Component {
  constructor(props) {
    super(props);
    this.changeProperty = this.changeProperty.bind(this);
    this.state = {
      fallbackMessage: "",
      filters: INITIAL_FILTERS,
      appliedFilters: INITIAL_FILTERS,
      parentDomain: "",
      childDomains: [],
      meterOptions: [COMBINE_METER],
      tableData: [],
      headers: [],
      showSidebar: false,
      searchValue: "",
      filteredTableData: [],
      loading: false,
      error: null,
      chartData: DEFAULT_CHART_DATA,
      selectedProperty: "",
      selectedPropertyObj: {},
      childcheckbox: true,
      all_properties: [],
      isExpandedView: document.body.classList.contains("screen-zoomin-out"),
      lastSelectedChildDomain: "", // state to track last selected child domain
      meterNames: [],
      lot_id: "",
      ticketReportLots: [],
    };
    this.chartRef = createRef();
  }

  async componentDidMount() {
    await this.props.get_all_properties();

    const allProperties = this.props.getAllProperties || [];
    const hostname = window.location.hostname.split(".")[0];

    // Try to find a property that matches the hostname subdomain
    let defaultProperty = allProperties.find((item) => item.domain === hostname);

    // Fallback to the first property in the list if no domain match
    if (!defaultProperty && allProperties.length > 0) {
      console.warn("No matching domain found. Falling back to first property in list.");
      defaultProperty = allProperties[0];
    }

    // Still nothing? Abort.
    if (!defaultProperty?.id) {
      console.error("No default property found. Audit report will not load.");
      return;
    }

    const selectedObj = {
      label: defaultProperty.site_name,
      value: defaultProperty.id,
    };

    // Always set up the observer — even if no data gets fetched
    this.setupMutationObserver();

    //   Fetch lots here
    await this.props.get_all_lots(defaultProperty.id);
    const currentLot = this.props.lots;

    this.setState(
      (prevState) => ({
        all_properties: allProperties,
        selectedPropertyObj: selectedObj,
        selectedProperty: selectedObj.value,
        initialProperty: defaultProperty, // storing default property for later use
        filters: {
          ...prevState.filters,
          parent_domain: defaultProperty.domain,
          child_domain: defaultProperty.domain,
          selectedProperty: selectedObj.value,
          selectedPropertyObj: selectedObj,
        },
        appliedFilters: {
          ...prevState.appliedFilters,
          parent_domain: defaultProperty.domain,
          child_domain: defaultProperty.domain,
          selectedProperty: selectedObj.value,
          selectedPropertyObj: selectedObj,
        },
        lastSelectedChildDomain: defaultProperty.domain,
        ticketReportLots: currentLot, //   set the lots here
      }),
      () => {
        this.init(); // Safe to fetch report data now
      },
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { auditDataMining } = this.props;
    const { filters, appliedFilters } = this.state;

    if (prevProps.auditDataMining !== auditDataMining && JSON.stringify(filters) === JSON.stringify(appliedFilters)) {
      console.log("Meter Names in state:", this.state.meterNames.meter_name);
      this.handleDataTransformation();
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  init = async () => {
    await this.fetchDomains();
    this.fetchAdvancedRevenueReportData();
  };

  getMeterLabel = (agentId) => {
    const meter = this.state.meterNames.find(
      (m) =>
        m.serial_number?.toString() === agentId?.toString() || // Match by serial_number
        m.id?.toString() === agentId?.toString(), // Fallback: match by id
    );
    return meter ? meter.meter_name : agentId;
  };

  setupMutationObserver = () => {
    const observer = new MutationObserver(() => {
      const isOpen = document.body.classList.contains("foc-open");
      const isZoom = document.body.classList.contains("screen-zoomin-out");
      this.setState({ showSidebar: isOpen });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    this.observer = observer;
  };

  fetchDomains = async () => {
    try {
      this.setState({ loading: true });

      const hostname = window.location.hostname;
      const parentDomainValue = hostname.split(".")[0];
      const allProperties = this.props.getAllProperties || [];

      // Try to match the parent property by domain
      const matchedParent = allProperties.find((p) => p.domain === parentDomainValue);

      // Fallback if no match found
      if (!matchedParent) {
        throw new Error("Could not find parent property matching hostname.");
      }

      // Get child domains that belong to this parent (by parent_id)
      const childDomains = allProperties.filter((p) => p.parent_id === matchedParent.id && p.domain !== matchedParent.domain);

      this.setState({
        parentDomain: parentDomainValue,
        childDomains,
        filters: {
          ...this.state.filters,
          parent_domain: matchedParent.domain,
          child_domain: matchedParent.domain, // You can default to parent or first child if you want
        },
        appliedFilters: {
          ...this.state.appliedFilters,
          parent_domain: matchedParent.domain,
          child_domain: matchedParent.domain,
        },
      });
    } catch (err) {
      const fallbackParentDomain = "Default Parent";
      this.setState({
        parentDomain: fallbackParentDomain,
        filters: { ...this.state.filters, parent_domain: fallbackParentDomain },
        appliedFilters: { ...this.state.appliedFilters, parent_domain: fallbackParentDomain },
        error: "Failed to load parent domain: " + err.message,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchAdvancedRevenueReportData = async () => {
    console.log("Fetching report data...");
    try {
      this.setState({ loading: true });
      console.log("Calling getAuditDataMining...");
      const { filters } = this.state;
      console.log("Selected meter:", this.state.filters.meter);
      await this.props.getAuditDataMining(filters);

      await this.fetchMeterNames();

      console.log("Redux auditDataMiningList:", this.props.auditDataMining.type);
    } catch (err) {
      console.error("Failed to load report data: ", err.message);
      this.setState({ error: "Failed to load report data: " + err.message });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleDataTransformation = () => {
    const { auditDataMining } = this.props;
    const { filters } = this.state;
    let filteredData = auditDataMining;

    if (filters.type === "Paid") {
      filteredData = auditDataMining.filter((item) => item.type === "Paid");
    } else if (filters.type === "Refunded") {
      filteredData = auditDataMining.filter((item) => item.type === "Refunded");
    }

    if (filteredData && filteredData.length > 0) {
      console.log("Data received from Redux:", auditDataMining);

      let showFields = filters.show;
      if (showFields.length === 0) {
        showFields = ["Value"];
        this.setState({
          fallbackMessage: "No display options selected. Please Select Either Sum Of Transactions or Count Of Transactions.",
        });
      } else {
        this.setState({ fallbackMessage: "" });
      }

      let displayColumns = ["summary_date", "child_domain"];

      let timeResolutionLabel = "Date";
      switch (filters.time_resolution) {
        case "Week":
          timeResolutionLabel = "Week";
          break;
        case "Month":
          timeResolutionLabel = "Month";
          break;
        case "Year":
          timeResolutionLabel = "Year";
          break;
        default:
          timeResolutionLabel = "Date";
      }
      let columnNames = [timeResolutionLabel];
      columnNames.push("Domain");
      columnNames.push("Type");
      displayColumns = ["summary_date"];
      displayColumns.push("child_domain");
      displayColumns.push("type");
      const isPieChart = filters.output === "pie_chart";
      const shouldShowEachMeter = !isPieChart && filters.meter === "-Show each meter-";
      const selectedMeter = filters.meter;
      if (isPieChart && filters.meter === "-Show each meter-") {
        filters.meter = "-Combine Together-";
      }

      // Add Meter column temporarily to reorder it after
      if (shouldShowEachMeter) {
        displayColumns.push("agent_id");
        columnNames.push("Meter");
      }

      switch (filters.payment_method) {
        case "CashVsCard":
          if (showFields.includes("Value")) {
            displayColumns.push("sum_cash", "sum_card");
            columnNames.push("Cash $", "Card $");
          }
          if (showFields.includes("Count")) {
            displayColumns.push("count_cash", "count_card");
            columnNames.push("Cash #", "Card #");
          }
          break;

        case "CreditVsDebit":
          if (showFields.includes("Value")) {
            displayColumns.push("sum_credit", "sum_debit");
            columnNames.push("Credit $", "Debit $");
          }
          if (showFields.includes("Count")) {
            displayColumns.push("count_credit", "count_debit");
            columnNames.push("Credit #", "Debit #");
          }
          break;

        case "OnlineVsAtMeter":
          if (showFields.includes("Value")) {
            displayColumns.push("passage_pass_sum", "parking_permit_sum", "citation_sum", "meter_sum");
            columnNames.push("PassagePass $", "ParkingPermit $", "Citation $", "Meter $");
          }
          if (showFields.includes("Count")) {
            displayColumns.push("passage_pass_count", "parking_permit_count", "citation_count", "meter_count");
            columnNames.push("PassagePass #", "ParkingPermit #", "Citation #", "Meter #");
          }
          break;

        case "Combined":
          if (showFields.includes("Value")) {
            displayColumns.push("sum_combined");
            columnNames.push("Total Sum");
          }
          if (showFields.includes("Count")) {
            displayColumns.push("count_combined");
            columnNames.push("Total Count");
          }
          break;

        default: {
          let paymentMethods = [
            { sum: "sum_cash", count: "count_cash", label: "Cash" },
            { sum: "sum_mastercard", count: "count_mastercard", label: "Master Card" },
            { sum: "sum_visa", count: "count_visa", label: "Visa" },
            { sum: "sum_interac", count: "count_interac", label: "Interac" },
            { sum: "sum_amex", count: "count_amex", label: "Amex" },
            { sum: "sum_discover", count: "count_discover", label: "Discover" },
            { sum: "sum_other", count: "count_other", label: "Other" },
            { sum: "sum_total", count: "count_total", label: "Total" },
          ];
          if (this.state.filters.output === "bar_chart" || this.state.filters.output === "stacked_bar_chart") {
            const total = paymentMethods.pop(); // remove "Total"
            paymentMethods = [total, ...paymentMethods]; // move "Total" to front
          }
          paymentMethods.forEach(({ sum, count, label }) => {
            const isStacked = this.state.filters.output.includes("stacked");
            const isTotal = sum.includes("total") || count.includes("total");
            if (isStacked && isTotal) return;
            if (showFields.includes("Value")) {
              displayColumns.push(sum);
              columnNames.push(`${label} $`);
            }
            if (showFields.includes("Count")) {
              displayColumns.push(count);
              columnNames.push(`${label} #`);
            }
          });
        }
      }
      // Move "agent_id" (Meter) to second column position
      const domainIndex = displayColumns.indexOf("child_domain");
      if (domainIndex > -1) {
        displayColumns.splice(domainIndex, 1);
        displayColumns.splice(1, 0, "child_domain");

        columnNames.splice(domainIndex, 1);
        columnNames.splice(1, 0, "Domain");
      }

      const meterIndex = displayColumns.indexOf("agent_id");
      if (meterIndex > -1) {
        displayColumns.splice(meterIndex, 1);
        displayColumns.splice(2, 0, "agent_id");

        columnNames.splice(meterIndex, 1);
        columnNames.splice(2, 0, "Meter");
      }
      let rows = filteredData.map((item) => {
        const row = displayColumns.map((key) => {
          if (key === "agent_id") return this.getMeterLabel(item[key]) || item[key];
          if (key === "type") return item.type ?? "Unknown";
          if (key === "child_domain") return item.child_domain || "Unknown";
          return item[key] !== undefined && item[key] !== null ? item[key].toString() : "0";
        });
        // Ensure agent_id is only present if we're showing each meter
        if (!shouldShowEachMeter) {
          const agentIdIndex = displayColumns.indexOf("agent_id");
          if (agentIdIndex !== -1) {
            row.splice(agentIdIndex, 1); // Safely remove agent_id if not needed
          }
        }
        if (filters.time_resolution === "Year") {
          row.rawDate = item.year || null;
        } else if (filters.time_resolution === "Day") {
          row.rawDate = (item.summary_date || "").split("T")[0]; // Ensure if its there that we strip time for day resolution
        } else {
          row.rawDate = item.summary_date; // leave as-is for Week/Month to preserve uniqueness
        }
        return row;
      });
      if (filters.time_resolution === "Month" || filters.time_resolution === "Week" || filters.time_resolution === "Year") {
        const groupedData = {};

        const fromDate = moment(filters.from_date, "YYYY-MM-DD");
        const typeIndex = columnNames.indexOf("Type");
        const meterIndex = columnNames.indexOf("Meter");
        rows.forEach((row) => {
          let dateKey = row.rawDate || row[0]; // fallback to 0 if rawDate isn't there
          if (!dateKey) return;

          if (filters.time_resolution === "Month") {
            const type = typeIndex !== -1 ? row[typeIndex] : null;
            const agentId = shouldShowEachMeter && meterIndex !== -1 ? row[meterIndex] : null;

            const baseMoment = moment(dateKey, ["YYYY-MM", "YYYY-MM-DD"]);
            if (!baseMoment.isValid()) return;

            const rawKey = baseMoment.format("YYYY-MM");
            const label = baseMoment.format("MMMM YYYY");
            const domain = row[columnNames.indexOf("Domain")] || "Unknown";
            const sortKey = shouldShowEachMeter ? `${rawKey}_${type}_${agentId}_${domain}` : `${rawKey}_${type}_${domain}`;

            // Debug log
            console.log("Grouping row with sortKey:", sortKey, "rawKey:", rawKey, "label:", label);

            if (!groupedData[sortKey]) {
              const newRow = row.slice();
              newRow[0] = label;
              newRow.rawDate = rawKey; // ✅ ensure it's on the row object
              groupedData[sortKey] = {
                row: newRow,
                rawDate: rawKey,
                label,
              };
            } else {
              for (let i = 1; i < row.length; i += 1) {
                groupedData[sortKey].row[i] = (parseFloat(groupedData[sortKey].row[i]) || 0) + (parseFloat(row[i]) || 0);
              }
            }
          } else if (filters.time_resolution === "Week") {
            const rowStartDate = moment(dateKey, "YYYY-MM-DD");
            let weekStart = rowStartDate.clone().startOf("week"); // Sunday
            let weekEnd = weekStart.clone().add(6, "days"); // Saturday

            const userToDate = moment(filters.to_date, "YYYY-MM-DD");
            if (weekEnd.isAfter(userToDate)) {
              weekEnd = userToDate.clone();
            }

            const type = typeIndex !== -1 ? row[typeIndex] : null;
            const agentId = shouldShowEachMeter && meterIndex !== -1 ? row[meterIndex] : null;

            const domain = row[columnNames.indexOf("Domain")] || "Unknown";
            const sortKey = shouldShowEachMeter
              ? `${weekStart.format("YYYY-MM-DD")}_${type}_${agentId}_${domain}`
              : `${weekStart.format("YYYY-MM-DD")}_${type}_${domain}`;

            const userFromDate = moment(filters.from_date, "YYYY-MM-DD");
            const displayStart = weekStart.isBefore(userFromDate) ? userFromDate.clone() : weekStart.clone();
            const label = `${displayStart.format("MM/DD")} - ${weekEnd.format("MM/DD/YY")}`;

            if (!groupedData[sortKey]) {
              const newRow = row.slice();
              newRow[0] = label;
              newRow.rawDate = `${displayStart.format("MM/DD")} - ${weekEnd.format("MM/DD/YY")}`; // ✅ proper label format

              groupedData[sortKey] = {
                row: newRow,
                rawDate: weekStart.format("YYYY-MM-DD"),
                label,
              };
            } else {
              for (let i = 1; i < row.length; i += 1) {
                groupedData[sortKey].row[i] = (parseFloat(groupedData[sortKey].row[i]) || 0) + (parseFloat(row[i]) || 0);
              }
            }

            return;
          } else if (filters.time_resolution === "Year") {
            const rowYear = moment(row.rawDate, "YYYY-MM-DD").year();
            const fromYear = moment(filters.from_date, "YYYY-MM-DD").year();
            const toYear = moment(filters.to_date, "YYYY-MM-DD").year();

            if (rowYear < fromYear || rowYear > toYear) return;

            const type = typeIndex !== -1 ? row[typeIndex] : null;
            const agentId = shouldShowEachMeter && meterIndex !== -1 ? row[meterIndex] : null;

            const yearStr = String(rowYear);
            const domain = row[columnNames.indexOf("Domain")] || "Unknown";
            const sortKey = shouldShowEachMeter ? `${yearStr}_${type}_${agentId}_${domain}` : `${yearStr}_${type}_${domain}`;

            if (!groupedData[sortKey]) {
              const initialRow = row.map((val, idx) => {
                if (idx === 0) return yearStr;

                const header = columnNames[idx];
                const isNumeric =
                  header.includes("$") || header.includes("#") || header.toLowerCase().includes("sum") || header.toLowerCase().includes("count");

                if (header === "Type") return type || "Unknown"; // ✅ Force-fill the type column
                if (header === "Domain") return row[columnNames.indexOf("Domain")] || "Unknown"; // ✅ Keep domain consistent

                if (isNumeric) {
                  const num = parseFloat(val);
                  return !Number.isNaN(num) ? num : 0;
                }
                return val;
              });

              groupedData[sortKey] = {
                row: initialRow,
                rawDate: yearStr,
                label: yearStr,
              };
            } else {
              for (let i = 1; i < row.length; i += 1) {
                const prev = parseFloat(groupedData[sortKey].row[i]) || 0;
                const curr = parseFloat(row[i]) || 0;
                groupedData[sortKey].row[i] = prev + curr;
              }
            }

            return;
          }
          if (!groupedData[dateKey]) {
            groupedData[dateKey] = {
              row: row.slice(), // full row for table
              rawDate: row[0], // valid ISO date for chart
              label: dateKey, // display label for table
            };
          } else {
            for (let i = 1; i < row.length; i += 1) {
              groupedData[dateKey][i] = (parseFloat(groupedData[dateKey][i]) || 0) + (parseFloat(row[i]) || 0);
            }
          }
        });
        rows = Object.entries(groupedData)
          .sort(([, a], [, b]) => new Date(a.rawDate) - new Date(b.rawDate)) // ✅ Sort by actual rawDate
          .map(([_, group]) => {
            if (!group.row || !Array.isArray(group.row)) return [];
            const updatedRow = [...group.row];
            updatedRow[0] = group.label;
            updatedRow.rawDate = group.rawDate;
            return updatedRow;
          });
        rows = rows.filter((row) => !/^\d{4}-\d{2}$/.test(row[0]));
      }
      // Filter out rows where all numeric columns total to 0
      rows = rows.filter((row) => {
        // Skip first column (date) and agent_id column if present
        const numericData = row.slice(1).filter((_, index) => {
          const header = columnNames[index + 1]; // +1 to skip date column
          return !Number.isNaN(parseFloat(row[index + 1]));
        });

        const total = numericData.reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
        return total !== 0;
      });
      const valueColIndex = columnNames.findIndex((name) => name.includes("$") || name.includes("Sum"));
      const chartData = rows.map((row) => {
        const labelIndex = 0;
        const typeIndex = columnNames.indexOf("Type");
        const meterIndex = columnNames.indexOf("Meter");

        const typeLabel = typeIndex !== -1 ? row[typeIndex] : "Unknown";
        const meterLabel = meterIndex !== -1 ? row[meterIndex] : null;
        const rawDate = row.rawDate || row[0];

        let dateLabel = "";
        if (filters.time_resolution === "Month") {
          dateLabel = moment(rawDate, "YYYY-MM").format("MMMM YYYY");
        } else if (filters.time_resolution === "Week") {
          const start = moment(rawDate, "YYYY-MM-DD").startOf("week");
          const end = start.clone().add(6, "days");
          const from = moment(filters.from_date, "YYYY-MM-DD");
          const to = moment(filters.to_date, "YYYY-MM-DD");

          const displayStart = start.isBefore(from) ? from : start;
          const displayEnd = end.isAfter(to) ? to : end;

          dateLabel = `${displayStart.format("MM/DD")} - ${displayEnd.format("MM/DD/YY")}`;
        } else if (filters.time_resolution === "Year") {
          dateLabel = rawDate;
        } else {
          dateLabel = moment(rawDate, "YYYY-MM-DD").format("MM/DD/YY");
        }

        const domainLabel = row[columnNames.indexOf("Domain")]; // <- safest dynamic check

        let formattedDate = "";

        if (filters.time_resolution === "Week" && typeof row[0] === "string" && row[0].includes("-")) {
          // Use the nice "MM/DD - MM/DD/YY" format already present
        } else if (filters.time_resolution === "Month") {
          formattedDate = moment(rawDate, ["YYYY-MM", "YYYY-MM-DD"]).format("MMMM YYYY");
        } else if (filters.time_resolution === "Year") {
          formattedDate = rawDate;
        } else {
          formattedDate = moment(rawDate, "YYYY-MM-DD").format("MM/DD/YY");
        }

        const fullLabel = `${formattedDate}${domainLabel ? ` | ${domainLabel}` : ""}${typeLabel ? ` | ${typeLabel}` : ""}${
          meterLabel ? ` | ${meterLabel}` : ""
        }`;
        console.log("Chart label:", fullLabel);
        const chartRow = [fullLabel, parseFloat(row[valueColIndex]) || 0];
        chartRow.rawDate = rawDate;
        return chartRow;
      });

      this.setState(
        {
          headers: columnNames,
          tableData: rows,
          chartData: [["Date", columnNames[valueColIndex]], ...chartData],
        },
        () => {
          this.applySearchFilter(rows);
        },
      );
    } else {
      this.setState({
        fallbackMessage: "No data available for the selected filters or Property.",
        tableData: [],
        headers: [],
        filteredTableData: [],
        chartData: DEFAULT_CHART_DATA,
      });
    }
  };

  formatCurrency = (value) => {
    return parseFloat(value || 0).toLocaleString("en-CA", {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  applySearchFilter = (data) => {
    const { filters, searchValue } = this.state;

    if (!data || data.length === 0) {
      this.setState({
        filteredTableData: [],
        chartData: DEFAULT_CHART_DATA,
      });
      return;
    }

    const fromDate = moment(filters.from_date, "YYYY-MM-DD");
    const toDate = moment(filters.to_date, "YYYY-MM-DD");

    let filteredData = data.filter((row) => {
      let isIncluded = false;
      let rowStartDate;
      const rawDate = row.rawDate || row[0];
      const timeRes = filters.time_resolution;

      if (timeRes === "Month") {
        const rowMonth = moment(rawDate, "YYYY-MM");
        const startOfRowMonth = rowMonth.clone().startOf("month");
        const endOfRowMonth = rowMonth.clone().endOf("month");

        isIncluded = endOfRowMonth.isSameOrAfter(fromDate) && startOfRowMonth.isSameOrBefore(toDate);
      } else if (timeRes === "Week") {
        if (typeof row[0] === "string" && row[0].includes("-")) {
          const start = row[0].split("-")[0].trim();
          rowStartDate = moment(start, "MM/DD/YYYY");
        } else {
          rowStartDate = moment(row[0], "YYYY-MM-DD");
        }

        isIncluded = rowStartDate.isValid() && rowStartDate.isBetween(fromDate, toDate, null, "[]");
      } else if (timeRes === "Year") {
        const rowYear = parseInt(row[0], 10);
        const fromYear = fromDate.year();
        const toYear = toDate.year();

        isIncluded = !Number.isNaN(rowYear) && rowYear >= fromYear && rowYear <= toYear;
      } else {
        rowStartDate = moment(row[0], "YYYY-MM-DD");
        isIncluded = rowStartDate.isValid() && rowStartDate.isBetween(fromDate, toDate, null, "[]");
      }

      return isIncluded;
    });

    if (searchValue) {
      filteredData = filteredData.filter((row) => row.some((cell) => typeof cell === "string" && cell.toLowerCase().includes(searchValue.toLowerCase())));
    }

    const sortedData = [...filteredData].sort((a, b) => new Date(b[0]) - new Date(a[0]));

    let finalChartData;

    if (filters.display_as === "Percentage") {
      const allowedFilters = ["CashVsCard", "CreditVsDebit", "OnlineVsAtMeter", "Combined", "Detailed"];
      const applyPercentage = allowedFilters.includes(filters.payment_method);

      const percentRows = sortedData.map((row) => {
        const typeIndex = this.state.headers.indexOf("Type");
        const meterIndex = this.state.headers.indexOf("Meter");

        const typeLabel = typeIndex !== -1 ? row[typeIndex] : "Unknown";
        const meterLabel = meterIndex !== -1 ? row[meterIndex] : null;

        const domainLabel = row[this.state.headers.indexOf("Domain")];
        const rawDate = row.rawDate || row[0];
        let formattedDate = "";

        if (filters.time_resolution === "Week") {
          const start = moment(rawDate, "YYYY-MM-DD").startOf("week");
          const end = start.clone().add(6, "days");

          const from = moment(filters.from_date, "YYYY-MM-DD");
          const to = moment(filters.to_date, "YYYY-MM-DD");

          const displayStart = start.isBefore(from) ? from : start;
          const displayEnd = end.isAfter(to) ? to : end;

          formattedDate = `${displayStart.format("MM/DD")} - ${displayEnd.format("MM/DD/YY")}`;
        } else if (filters.time_resolution === "Year") {
          formattedDate = rawDate;
        } else if (filters.time_resolution === "Month") {
          formattedDate = moment(rawDate, ["YYYY-MM", "YYYY-MM-DD"]).format("MMMM YYYY");
        } else {
          formattedDate = moment(rawDate, "YYYY-MM-DD").format("MM/DD/YY");
        }

        const rawLabel = `${formattedDate}${domainLabel ? ` | ${domainLabel}` : ""}${typeLabel ? ` | ${typeLabel}` : ""}${
          meterLabel ? ` | ${meterLabel}` : ""
        }`;
        const shortDate = rawLabel;

        const valueHeaders = this.state.headers.slice(1).filter((label) => {
          const isDollar = label.includes("$") && !label.toLowerCase().includes("total");
          const isCount = label.includes("#") && !label.toLowerCase().includes("total");
          return applyPercentage && ((filters.show.includes("Value") && isDollar) || (filters.show.includes("Count") && isCount));
        });

        const valueIndices = valueHeaders.map((label) => this.state.headers.indexOf(label));
        const valueData = valueIndices.map((i) => parseFloat(row[i]) || 0);
        const valueTotal = valueData.reduce((a, b) => a + b, 0) || 1;
        const valuePercents = valueData.map((v) => parseFloat(((v / valueTotal) * 100).toFixed(2)));

        const countHeaders = this.state.headers.slice(1).filter((label) => label.includes("#") && !label.toLowerCase().includes("total"));
        const countIndices = countHeaders.map((label) => this.state.headers.indexOf(label));
        const countData = countIndices.map((i) => parseFloat(row[i]) || 0);
        const countTotal = countData.reduce((a, b) => a + b, 0) || 1;
        const countPercents = countData.map((v) => parseFloat(((v / countTotal) * 100).toFixed(2)));

        return [shortDate, ...valuePercents];
      });

      const allPercentHeaders = [
        "Date",
        ...this.state.headers
          .filter((h) => (h.includes("$") || h.includes("#")) && !h.toLowerCase().includes("total"))
          .map((h) => h.replace(" $", "").replace(" #", "") + " (%)"),
      ];

      finalChartData = [allPercentHeaders, ...percentRows];
    } else {
      const valueHeaders = this.state.headers.slice(1).filter((label) => {
        const lower = label.toLowerCase();
        return filters.show.includes("Value") ? lower.includes("sum") || label.includes("$") : lower.includes("count") || label.includes("#");
      });

      // Create header row with annotations
      const chartHeaders = ["Date"];
      valueHeaders.forEach((label) => {
        chartHeaders.push(label); // Value
        chartHeaders.push({ type: "string", role: "annotation" }); // Annotation column
      });
      // Create data rows with annotations for peaks
      const chartRows = sortedData.map((row) => {
        let rawDate = row.rawDate || row[0];
        let formattedDate = "";

        if (filters.time_resolution === "Week") {
          const start = moment(rawDate, "YYYY-MM-DD").startOf("week");
          const end = start.clone().add(6, "days");

          const from = moment(filters.from_date, "YYYY-MM-DD");
          const to = moment(filters.to_date, "YYYY-MM-DD");

          const displayStart = start.isBefore(from) ? from : start;
          const displayEnd = end.isAfter(to) ? to : end;

          formattedDate = `${displayStart.format("MM/DD")} - ${displayEnd.format("MM/DD/YY")}`;
        } else if (filters.time_resolution === "Year") {
          formattedDate = rawDate;
        } else if (filters.time_resolution === "Month") {
          formattedDate = moment(rawDate, ["YYYY-MM", "YYYY-MM-DD"]).format("MMMM YYYY");
        } else {
          formattedDate = moment(rawDate, "YYYY-MM-DD").format("MM/DD/YY");
        }

        const typeIndex = this.state.headers.indexOf("Type");
        const meterIndex = this.state.headers.indexOf("Meter");

        const typeLabel = typeIndex !== -1 ? row[typeIndex] : "Unknown";
        const meterLabel = meterIndex !== -1 && filters.meter === "-Show each meter-" ? row[meterIndex] : null;

        const domainLabel = row[this.state.headers.indexOf("Domain")]; // <- Safely pull domain
        const rawLabel =
          row.label || `${formattedDate}${domainLabel ? ` | ${domainLabel}` : ""}${typeLabel ? ` | ${typeLabel}` : ""}${meterLabel ? ` | ${meterLabel}` : ""}`;
        // Prefix with a bullet or text to prevent date parsing
        const fullLabel = rawLabel;
        const dataRow = [fullLabel];
        console.log("Final chart label for row:", fullLabel);
        valueHeaders.forEach((label) => {
          const colIdx = this.state.headers.indexOf(label);
          const val = parseFloat(row[colIdx]) || 0;
          const isPeak = val > 5000;
          dataRow.push(val);
          dataRow.push(isPeak ? this.formatCurrency(val) : null); // Show value as annotation on peak
        });

        return dataRow;
      });

      finalChartData = [chartHeaders, ...chartRows];
    }
    this.setState({
      filteredTableData: sortedData,
      chartData: finalChartData || DEFAULT_CHART_DATA,
    });
  };

  handleSearchChange = (e) => {
    const value = e.target.value.trim();
    this.setState({ searchValue: value }, () => {
      this.applySearchFilter(this.state.tableData);
    });
  };

  handleChange = (e) => {
    const { name, value, checked } = e.target;
    this.setState((prevState) => {
      if (name === "show") {
        const newShow = checked ? [...prevState.filters.show, value] : prevState.filters.show.filter((v) => v !== value);
        return { filters: { ...prevState.filters, show: newShow } };
      }

      if (name === "child_domain") {
        const newMeterOptions = value === "-Combine Properties-" ? [COMBINE_METER] : ["-Show each meter-", COMBINE_METER];
        return {
          filters: { ...prevState.filters, [name]: value },
          meterOptions: newMeterOptions,
          lastSelectedChildDomain: value !== ALL_CHILD_DOMAIN ? value : prevState.lastSelectedChildDomain,
        };
      }

      if (name === "lot_id") {
        return {
          filters: { ...prevState.filters, lot_id: value },
          lot_id: value,
        };
      }

      return { filters: { ...prevState.filters, [name]: value } };
    });
  };

  handleChartPDFExport = () => {
    if (!this.chartRef.current) return;

    const imageURI = this.chartRef.current.getChart().getImageURI();
    const now = moment().format("YYYY-MM-DD");
    const { parentDomain, appliedFilters, filters, all_properties } = this.state;

    // Correct property name used here
    const selectedPropertyFullObj = all_properties.find((p) => p.id === filters.selectedProperty);
    const siteName = selectedPropertyFullObj?.site_name || parentDomain.toUpperCase();
    const siteAddress = selectedPropertyFullObj?.address || "Address Unknown";

    const title = `
    <div style="text-align:center; font-family:Arial, sans-serif; margin-bottom: 20px;">
      <h1 style="margin:0; font-size: 24px;">Advanced Revenue Chart</h1>
      <p style="margin:0; font-size: 16px; font-weight: bold;">${siteName}</p>
      <p style="margin:0; font-size: 14px;">${siteAddress}</p>
      <p style="margin:5px 0; font-size: 14px;"> ${appliedFilters.from_date} to ${appliedFilters.to_date}</p>
      <p style="margin:0; font-size: 12px;">Generated on: ${now}</p>
    </div>
  `;

    const win = window.open("");
    win.document.write(`
    <html>
      <head><title>${siteName} - Advanced Revenue Chart</title></head>
      <body style="margin:0; padding:20px; font-family:Arial, sans-serif;">
        ${title}
        <img src="${imageURI}" style="width:100%; max-width:1000px; display:block; margin:0 auto;" />
        <script>
          setTimeout(() => {
            window.print();
            window.close();
          }, 1000);
        </script>
      </body>
    </html>
  `);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log("Filters applied:", this.state.filters);

    const updatedFilters = {
      ...this.state.filters,
      from_date: moment(this.state.filters.from_date).format("YYYY-MM-DD"),
      to_date: moment(this.state.filters.to_date).format("YYYY-MM-DD"),
    };

    this.setState({ appliedFilters: updatedFilters }, () => {
      this.fetchAdvancedRevenueReportData();
      this.setState({ showSidebar: false });
      document.body.classList.remove("foc-open");
    });
  };

  handleReset = async () => {
    const { initialProperty, childcheckbox } = this.state;

    const selectedProperty = initialProperty?.id || "";
    const selectedPropertyObj = this.state.all_properties.find((p) => p.id === initialProperty?.id);

    await this.props.get_all_lots(selectedProperty);
    const currentLot = this.props.lots;

    const resetFilters = {
      ...INITIAL_FILTERS,
      selectedProperty,
      selectedPropertyObj: {
        label: selectedPropertyObj?.site_name || "",
        value: selectedProperty,
      },
      from_date: moment().subtract(29, "days").format("YYYY-MM-DD"),
      to_date: moment().format("YYYY-MM-DD"),
      include_child_sites: true,
      lot_id: "",
    };

    this.setState(
      {
        filters: resetFilters,
        selectedProperty,
        selectedPropertyObj: resetFilters.selectedPropertyObj,
        searchValue: "",
        lot_id: "",
        ticketReportLots: currentLot,
        disableLotDropdown: currentLot.length < 1 || childcheckbox,
        childcheckbox: true,
      },
      () => {
        this.fetchMeterNames();
      },
    );
  };

  toggleSidebar = () => {
    this.setState(
      (prevState) => ({ showSidebar: !prevState.showSidebar }),
      () => {
        document.body.classList.remove("foc-open");
        if (this.state.showSidebar) {
          document.body.classList.add("foc-open");
        }
      },
    );
  };

  fetchMeterNames = async () => {
    try {
      const propertyId = this.state.filters.selectedProperty || this.state.filters.selectedPropertyObj?.value;
      if (!propertyId) {
        console.warn("No property selected for meter name fetching.");
        return;
      }

      const data = await this.props.get_all_meters(propertyId); // [{ id, meter_name }]
      console.log("Fetched meters:", data);

      const validMeters = (data || []).filter((m) => m?.type === "PaymentKiosk" && !!m.meter_name?.trim());
      const dynamicMeters = validMeters.map((m) => ({
        label: m.meter_name,
        value: m.id,
      }));

      const shouldIncludeEachMeter = dynamicMeters.length >= 1;

      const meterOptions = [
        ...(shouldIncludeEachMeter ? [{ label: "Show Each Meter", value: "-Show each meter-" }] : []),
        { label: "All Meters", value: "-Combine Together-" },
        ...dynamicMeters,
      ];

      this.setState((prevState) => {
        const selected = prevState.filters.meter;
        const validValues = meterOptions.map((opt) => opt.value);
        const safeMeter = validValues.includes(selected) ? selected : "-Combine Together-";

        return {
          meterNames: validMeters,
          meterOptions,
          filters: {
            ...prevState.filters,
            meter: safeMeter,
          },
        };
      });
    } catch (error) {
      console.error("Failed to fetch meter names:", error);
    }
  };

  exportPDFTable = async () => {
    const { appliedFilters, headers, filteredTableData, auditDataMining, domain } = this.state;
    const shouldExcludeType = ["Year", "Month", "Week"].includes(appliedFilters?.time_resolution);
    const filteredIndices = headers.reduce((acc, header, idx) => {
      const isTypeCol = header.toLowerCase() === "type";

      const shouldExclude = false; // always include type

      if (shouldExclude && isTypeCol) return acc;
      acc.push(idx);
      return acc;
    }, []);
    const filteredHeaders = filteredIndices.map((idx) => headers[idx]);
    // Find site name and address for selected property (if not already in filters)
    // Use selectedProperty value (id) to find full object from all_properties
    const selectedPropertyFullObj = this.state.all_properties.find((p) => p.id === this.state.filters.selectedProperty);
    const siteName = selectedPropertyFullObj?.site_name || "Site Name Unknown";
    const siteAddress = selectedPropertyFullObj?.address || "Site Address Unknown";
    console.log("Selected Property:", selectedPropertyFullObj);
    console.log("Exporting PDF with siteName:", siteName, "and siteAddress:", siteAddress);
    try {
      const exportData = {
        headers: filteredHeaders,
        rows: filteredTableData.map((row) => {
          return filteredIndices.map((idx) => row[idx]);
        }),
        appliedFilters,
        meterNames: this.state.meterNames,
        timezones: filteredTableData
          .filter((row) => row && Array.isArray(row))
          .map((row, rowIndex) => {
            const originalRow = auditDataMining && auditDataMining[rowIndex] ? auditDataMining[rowIndex] : {};
            return originalRow.time_zone || "UTC";
          }),
        domain: this.state.parentDomain || domain || "Default Domain",
        siteName,
        siteAddress,
      };
      const bufferData = await this.props.exportAuditMiningPDF(exportData);

      if (bufferData) {
        const blob = new Blob([bufferData], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Advanced-Revenue-${moment().format("YYYYMMDD-hhmmss")}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error exporting Audit Mining PDF:", error);
    }
  };

  exportXLSTable = async () => {
    const { appliedFilters, headers, filteredTableData, auditDataMining } = this.state;
    console.log("filteredTableData:", filteredTableData);
    if (!filteredTableData || !Array.isArray(filteredTableData) || filteredTableData.length === 0) {
      console.error("Error: filteredTableData is empty or invalid");
      return;
    }

    const filteredHeaders = headers;
    const columnTotals = {};
    filteredHeaders.forEach((header, idx) => {
      const lower = header.toLowerCase();
      if (!["meter", "type", "date", "domain", "week", "month", "year"].includes(lower)) {
        const total = filteredTableData.reduce((sum, row) => {
          const value = parseFloat(row[idx]);
          return sum + (Number.isNaN(value) ? 0 : value);
        }, 0);
        columnTotals[header] = total;
      }
    });

    const footerRow = filteredHeaders.map((header) => {
      const lower = header.toLowerCase();

      if (["date", "week", "month", "year"].includes(lower)) return "TOTALS";
      if (["meter", "type", "domain"].includes(lower)) return " ";

      const total = columnTotals[header];
      if (typeof total !== "number") return "";

      if (header.includes("$") && !header.includes("#")) {
        return this.formatCurrency(total);
      }

      return total;
    });

    try {
      const exportData = {
        headers: filteredHeaders,
        rows: [
          ...filteredTableData
            .filter((row) => row && Array.isArray(row))
            .map((row, rowIndex) => {
              return filteredHeaders.map((header, idx) => {
                const originalIdx = headers.indexOf(header);
                const cell = row[originalIdx];
                const filters = appliedFilters;
                const raw = parseFloat(cell);
                if (idx === 0) {
                  // ✅ Strip "From:" for week resolution
                  if (appliedFilters?.time_resolution === "Week") {
                    return typeof cell === "string" ? cell.replace(/^From:\s*/i, "") : cell;
                  }
                  return cell;
                }
                if (header.toLowerCase() === "domain") {
                  const originalRow = auditDataMining?.[rowIndex];
                  const domainValue = originalRow?.child_domain || cell;
                  return typeof domainValue === "string" ? domainValue : domainValue?.toString?.() ?? "";
                }

                if (["type", "meter"].includes(header.toLowerCase())) {
                  return typeof cell === "string" ? cell : cell?.toString?.() ?? "";
                }
                if (filters.meter === "-Show each meter-" && originalIdx === 2) {
                  return cell;
                }
                const isDollar = header.includes("$") && !header.includes("#");
                const isPercentageMode = filters.display_as === "Percentage";
                if (isPercentageMode && isDollar && !header.toLowerCase().includes("total")) {
                  const relevantIndices = headers
                    .map((h, i) => ({ h, i }))
                    .filter(({ h }) => h.includes("$") && !h.toLowerCase().includes("total"))
                    .map(({ i }) => i);
                  const rowTotal =
                    relevantIndices.reduce((sum, i) => {
                      const val = parseFloat(row[i]);
                      return sum + (Number.isNaN(val) ? 0 : val);
                    }, 0) || 1;
                  return !Number.isNaN(raw) ? raw / rowTotal : 0;
                }
                if (header.toLowerCase() === "domain") {
                  return typeof cell === "string" ? cell : cell?.toString?.() ?? "";
                }
                return Number.isNaN(raw) ? 0 : raw;
              });
            }),
          footerRow.map((cell, idx) => {
            const header = filteredHeaders[idx];
            const lower = header.toLowerCase();

            // If it's already an empty string, preserve it
            if (cell === "") return "";

            // Special case for "TOTALS" label
            if (cell === "TOTALS") return cell;

            const isDollar = header.includes("$") && !header.includes("#");
            const isCount = header.includes("#") && !header.toLowerCase().includes("total");
            const isPercentageMode = appliedFilters?.display_as === "Percentage";

            const val = typeof cell === "string" ? parseFloat(cell.replace(/[^0-9.-]+/g, "")) : parseFloat(cell);

            if (!Number.isNaN(val)) {
              if (isPercentageMode && (isDollar || isCount)) {
                return val;
              }
              return val;
            }

            return "";
          }),
        ],
        appliedFilters,
        meterNames: this.state.meterNames,
        timezones: filteredTableData
          .filter((row) => row && Array.isArray(row))
          .map((row, rowIndex) => {
            const originalRow = auditDataMining && auditDataMining[rowIndex] ? auditDataMining[rowIndex] : {};
            console.log(`Row ${rowIndex} time_zone:`, originalRow.time_zone); // Debug timezone
            return originalRow.time_zone || "UTC"; // Use time_zone field
          }),
      };

      console.log("exportData:", exportData);

      const bufferData = await this.props.exportAuditMiningXLS(exportData);

      if (bufferData) {
        const blob = new Blob([bufferData], {
          type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `ADVANCED-REVENUE-${moment().format("YYYYMMDD-hhmmss")}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error exporting Audit Mining XLSX:", error);
    }
  };

  getFormattedDuration = () => {
    const { appliedFilters } = this.state;
    const from = moment(appliedFilters.from_date, "YYYY-MM-DD");
    const to = moment(appliedFilters.to_date, "YYYY-MM-DD");

    switch (appliedFilters.time_resolution) {
      case "Year":
        return `${from.startOf("year").format("YYYY-MM-DD")} to ${to.endOf("year").format("YYYY-MM-DD")}`;
      case "Month":
        return `${from.startOf("month").format("YYYY-MM-DD")} to ${to.endOf("month").format("YYYY-MM-DD")}`;
      default:
        return `${from.format("YYYY-MM-DD")} to ${to.format("YYYY-MM-DD")}`;
    }
  };

  changeProperty(event) {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 90);

    this.setState(
      (prevState) => ({
        selectedProperty: event.value,
        selectedPropertyObj: event,
        filters: {
          ...prevState.filters,
          selectedProperty: event.value,
          selectedPropertyObj: event,
        },
        startDate: new Date(datebeforeThirtyDays),
        endDate: new Date(),
        month: null,
      }),
      async () => {
        const selectedPropertyObj = this.state.all_properties.find((item) => item.id === this.state.selectedProperty);

        this.props.selected_Property(selectedPropertyObj);
        await this.props.get_all_lots(event.value); //  ensure this is awaited
        const currentLot = this.props.lots;
        this.setState({
          ticketReportLots: currentLot,
          lot_id: "", // reset lot selection on property change
        });
        await this.fetchMeterNames();
      },
    );
  }

  renderChart = () => {
    const { appliedFilters, filters } = this.state;
    let chartData = [...this.state.chartData];
    const isCountMode = appliedFilters.show.includes("Count") && !appliedFilters.show.includes("Value");
    const output = appliedFilters.output;
    const hasSum = appliedFilters.show.includes("Value");
    const hasCount = appliedFilters.show.includes("Count");
    const showCountOnly = hasCount && !hasSum;
    const isPieChart = output === "pie_chart";
    const isBarChart = output === "bar_chart";
    const isBarChartStacked = output === "stacked_bar_chart";
    const isAreaChart = output === "area_chart";
    const isAreaChartStacked = output === "stacked_area_chart";
    const isPercentage = appliedFilters.display_as === "Percentage";
    const isStacked = output.includes("stacked");
    const titleMetric = isPercentage ? (showCountOnly ? "Count (%)" : "Amount (%)") : showCountOnly ? "Count" : "Sum";

    // PIE CHART
    if (isPieChart && appliedFilters.meter === "-Show each meter-") appliedFilters.meter = "-Combine Together-";
    if (isPieChart) {
      const options = {
        title: `Duration: ${this.getFormattedDuration()} | Meter: ${
          appliedFilters.meter === "-Combine Together-" ? "All" : "Individual"
        } | Display: ${titleMetric}`,
        is3D: true,
        legend: { position: "right" },
        pieSliceText: "none",
        pieSliceTextStyle: { color: "black", fontSize: 15 },
      };

      if (chartData.length <= 1) {
        return <div>No data available for Pie Chart</div>;
      }
      const rawHeaders = chartData[0].slice(1); // Skip Date
      const rawValues = chartData[0].slice(1).map((_, colIdx) => {
        return chartData.slice(1).reduce((sum, row) => {
          const val = parseFloat(row[colIdx + 1]); // +1 because we're skipping the date
          return sum + (Number.isNaN(val) ? 0 : val);
        }, 0);
      });
      const pieChartData = [["Category", isPercentage ? "Percentage" : showCountOnly ? "Count" : "Value"]];
      const values = [];

      rawHeaders.forEach((header, idx) => {
        const labelText = typeof header === "string" ? header : header?.label || "";
        const normLabel = labelText.toLowerCase();

        const isTotal = normLabel.includes("total");
        const isPercentageCol = normLabel.includes("%");
        const isDollar = normLabel.includes("$") || normLabel.includes("value");
        const isCount = normLabel.includes("#") || normLabel.includes("count");

        const forceSumOnly = isPercentage && hasSum && hasCount;
        const shouldUse = isPercentage ? isPercentageCol : showCountOnly ? isCount : isDollar || isCount;

        if (shouldUse && !isTotal) {
          const val = parseFloat(rawValues[idx]) || 0;
          values.push({
            label: labelText.replace(/\s?\$|\s?#|\s?\(%\)/g, "").trim(),
            value: val,
          });
        }
      });

      if (values.length === 0) {
        console.warn("Pie Chart: No matching headers for display mode", { rawHeaders, appliedFilters });
        return <div>No data available for Pie Chart</div>;
      }

      const total = values.reduce((sum, item) => sum + item.value, 0) || 1;

      const seen = new Set();

      values.forEach(({ label, value }) => {
        if (seen.has(label)) return; // Because columns follow a#,a$, b#, b$, etc. we can skip count unless explicitliy selected to ensure datas not duplicated
        seen.add(label);

        const percent = total ? Math.round((value / total) * 100 * 100) / 100 : 0;
        const displayValue = isPercentage ? percent : value;
        const displayLabel = isPercentage ? `${label} (${percent.toFixed(1)}%)` : label;
        pieChartData.push([displayLabel, displayValue]);
      });

      return (
        <Chart
          chartType="PieChart"
          width="100%"
          height="500px"
          data={pieChartData}
          options={options}
          loader={<div>Loading Pie Chart...</div>}
          chartWrapperParams={{ chartType: "PieChart" }}
          getChartWrapper={(chartWrapper) => {
            this.chartRef.current = chartWrapper;
          }}
        />
      );
    }

    // BAR / AREA CHARTS
    const chartTypeMap = {
      bar_chart: "ColumnChart",
      stacked_bar_chart: "ColumnChart",
      area_chart: "AreaChart",
      stacked_area_chart: "AreaChart",
      pie_chart: "PieChart",
    };

    const chartType = chartTypeMap[output] || "AreaChart";
    // If in Percentage mode, add null annotations so column count matches
    if (isPercentage) {
      const percentageHeader = chartData[0];
      const fixedHeader = [];

      // Add annotation column after each data column (skip "Date")
      percentageHeader.forEach((col, i) => {
        fixedHeader.push(col);
        if (i > 0) fixedHeader.push({ type: "string", role: "annotation" });
      });

      const fixedRows = chartData.slice(1).map((row) => {
        const newRow = [];
        row.forEach((val, i) => {
          newRow.push(val);
          if (i > 0) newRow.push(null); // dummy annotation
        });
        return newRow;
      });

      chartData = [fixedHeader, ...fixedRows];
    }
    // Annotate peak values
    const skipAnnotation = isPercentage;
    chartData = chartData.map((row, idx) => {
      const newRow = [...row];
      newRow[0] = String(newRow[0]); // force label to be string
      return newRow;
    });
    const annotatedData = skipAnnotation ? chartData : [chartData[0]];

    const totals = chartData.slice(1).map((row, index) => {
      let sum = 0;
      for (let i = 1; i < row.length; i += 2) {
        sum += typeof row[i] === "number" ? row[i] : 0;
      }
      return { index, total: sum };
    });
    if (!isPercentage) {
      const totals = chartData.slice(1).map((row, index) => {
        let sum = 0;
        for (let i = 1; i < row.length; i += 2) {
          sum += typeof row[i] === "number" ? row[i] : 0;
        }
        return { index, total: sum };
      });
    }

    const top3Indexes = totals
      .sort((a, b) => b.total - a.total)
      .slice(0, 3)
      .map((item) => item.index);
    if (!skipAnnotation) {
      chartData.slice(1).forEach((row, rowIndex) => {
        const newRow = [row[0]]; // First column is Date

        let rowTotal = 0;
        let lastNonZeroColIndex = -1;

        //   Step 1: Compute total and track the last non-zero value column (top of stack)
        for (let i = 1; i < row.length; i += 2) {
          const value = typeof row[i] === "number" ? row[i] : 0;
          rowTotal += value;

          if (isStacked && value > 0) {
            lastNonZeroColIndex = i;
          }
        }

        //   Step 2: Push values and place annotation at the correct column
        for (let i = 1; i < row.length; i += 2) {
          newRow.push(row[i]);

          if (isStacked) {
            // Stacked Bar: Annotate top bar (last non-zero) Skip annoting the first bar as it causes it to overlap with the y axis label
            if (top3Indexes.includes(rowIndex) && i === row.length - 2 && rowIndex !== 0) {
              const formattedTotal = isCountMode
                ? rowTotal.toLocaleString("en-CA")
                : `$${rowTotal.toLocaleString("en-CA", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
              newRow.push(formattedTotal);
            } else {
              newRow.push(null);
            }
          } else {
            // Non-stacked (Bar, Area, etc): Annotate only the Total column
            const label = chartData[0][i];
            const isTotalCol = typeof label === "string" && label.toLowerCase().includes("total");

            if (top3Indexes.includes(rowIndex) && isTotalCol && rowIndex !== 0) {
              const formatted = isCountMode
                ? row[i].toLocaleString("en-CA")
                : `$${row[i].toLocaleString("en-CA", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
              newRow.push(formatted);
            } else {
              newRow.push(null);
            }
          }
        }
        if (isStacked) {
          // Remove Total $ column(s) to avoid double-counting in stack
          const totalColIndexes = chartData[0]
            .map((label, idx) => (typeof label === "string" && label.toLowerCase().includes("total") ? idx : null))
            .filter((idx) => idx !== null);

          chartData = chartData.map((row) => row.filter((_, idx) => !totalColIndexes.includes(idx)));
        }
        annotatedData.push(newRow);
      });
    }
    // Dynamically calculate max stack height for vAxis
    let maxStackValue = 0;
    if ((isBarChart || isBarChartStacked) && !isPercentage) {
      maxStackValue = Math.max(
        ...annotatedData.slice(1).map((row) => row.reduce((sum, val, idx) => (idx % 2 === 1 && typeof val === "number" ? sum + val : sum), 0)),
      );
    }

    const options = {
      title: `Duration: ${this.getFormattedDuration()} | Meter: ${
        appliedFilters.meter === "-Combine Together-" ? "All" : "Individual"
      } | Display: ${titleMetric}`,
      height: 700,
      isStacked,
      fontName: "Arial",
      fontSize: 14,
      legend: {
        position: "top",
        textStyle: {
          fontSize: 14,
          bold: true,
          color: "#000",
        },
      },

      hAxis: {
        minValue: 0,
        title:
          isBarChart || isBarChartStacked || isAreaChart || isAreaChartStacked
            ? "Date"
            : isCountMode
            ? isPercentage
              ? "Count (%)"
              : "Count"
            : isPercentage
            ? "Amount (%)"
            : "Amount ($)",
        titleTextStyle: { bold: true, fontSize: 16 },
        textStyle: { fontSize: 12, bold: true },
        format: isPercentage ? "#'%'" : isCountMode ? null : "currency",
        slantedText: (isBarChart || isBarChartStacked) && ["Day", "Week", "Month"].includes(appliedFilters.time_resolution),

        slantedTextAngle: (isBarChart || isBarChartStacked) && ["Day", "Week", "Month"].includes(appliedFilters.time_resolution) ? 45 : 0,
      },
      vAxis: {
        title:
          isBarChart || isBarChartStacked || isAreaChart || isAreaChartStacked
            ? isCountMode
              ? isPercentage
                ? "Count (%)"
                : "Count"
              : isPercentage
              ? "Amount (%)"
              : "Amount ($)"
            : `Duration: ${moment(appliedFilters.from_date).format("YY-MM-DD")} to ${moment(appliedFilters.to_date).format("YY-MM-DD")}`,
        titleTextStyle: { bold: true, fontSize: 16 },
        textStyle: { fontSize: 12, bold: true },
        format: isBarChart || isBarChartStacked ? null : isPercentage ? "#'%'" : isCountMode ? null : "currency",
        maxValue:
          isStacked && !isPercentage
            ? Math.ceil(
                Math.max(...annotatedData.slice(1).map((row) => row.reduce((sum, val, i) => (i % 2 === 1 && typeof val === "number" ? sum + val : sum), 0))) *
                  1.1,
              )
            : (isBarChart || isAreaChart) && !isPercentage
            ? Math.ceil(
                Math.max(...annotatedData.slice(1).map((row) => row.reduce((sum, val, i) => (i % 2 === 1 && typeof val === "number" ? sum + val : sum), 0))) *
                  0.51,
              )
            : null,
      },

      enableInteractivity: true,
      isHtml: true,
      tooltip: {
        isHtml: false, // keep as false if not using custom HTML
        textStyle: {
          fontSize: 13,
        },
        format: isPercentage ? "#,##0.00'%'" : undefined,
      },
      bar: {
        groupWidth: "85%",
      },
      chartArea: {
        left: 120,
        right: 40,
        top: 120,
        bottom: 260,
        width: "92%",
        height: "80%",
      },
      annotations: {
        alwaysOutside: true,
        textStyle: {
          fontSize: 12,
          auraColor: "none",
          color: "#000",
          bold: true,
        },
      },
    };

    return (
      <Chart
        chartType={chartType}
        width="100%"
        height="700px"
        data={annotatedData}
        options={options}
        loader={<div> Loading Chart...</div>}
        chartWrapperParams={{ chartType }}
        getChartWrapper={(chartWrapper) => {
          this.chartRef.current = chartWrapper;
        }}
      />
    );
  };

  render() {
    const {
      fallbackMessage,
      filters,
      appliedFilters,
      parentDomain,
      meterOptions,
      tableData,
      headers,
      showSidebar,
      searchValue,
      filteredTableData,
      loading,
      error,
      chartData,
    } = this.state;
    const isYearly = appliedFilters?.time_resolution === "Year";
    const isMonthly = appliedFilters?.time_resolution === "Month";
    const columnTotals = headers.slice(1).map((header, idx) => {
      const colIndex = idx + 1;
      const total = filteredTableData.reduce((sum, row) => {
        const value = parseFloat(row[colIndex]);
        return sum + (Number.isNaN(value) ? 0 : value);
      }, 0);
      return { label: header, total };
    });

    if (loading) return <Loader />;
    if (error) return <div>Error: {error}</div>;
    console.log("Filtered Table Data:", filteredTableData);

    return (
      <div className="report-container">
        <Card className="mb-0">
          <Card.Body
            className="pos-rel-overflow-hide"
            style={{
              overflow: this.state.isExpandedView ? "visible" : undefined,
              minHeight: this.state.isExpandedView ? "100vh" : undefined,
            }}
          >
            <header>
              <div className="active-permit-header d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-0">Advanced Revenue Report</h5>
                {appliedFilters.output === "table" ? (
                  <div className="d-flex align-items-center">
                    <DatatableHeader searchValue={searchValue} HandleChange={this.handleSearchChange} onFilterIconClick={this.toggleSidebar} hideExpandIcon />
                    <Dropdown>
                      <Dropdown.Toggle as={CustomToggle} id="table-export-dropdown" />
                      <Dropdown.Menu className="min-w-100px">
                        <Dropdown.Item onClick={this.exportPDFTable}>PDF</Dropdown.Item>
                        <Dropdown.Item onClick={this.exportXLSTable}>XLSX</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <Button
                      variant="light"
                      className="btn-sm border-0 bg-light rounded-circle w-30px h-30px d-flex align-items-center justify-content-center mr-2"
                      onClick={this.toggleSidebar}
                    >
                      <i className="fa fa-filter" />
                    </Button>
                    <Dropdown>
                      <Dropdown.Toggle as={CustomToggle} id="chart-export-dropdown" />
                      <Dropdown.Menu className="min-w-100px">
                        <Dropdown.Item onClick={this.handleChartPDFExport}>Export Chart to PDF</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </header>
            {showSidebar && (
              <div className="sidebarFilter show">
                <Card className="contact-container mb-0">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between">
                      <Card.Title as="h4">Filters</Card.Title>
                      <Button
                        className="btn btn-sm border-0 bg-light rounded-circle w-30px h-30px d-flex align-items-center justify-content-center"
                        onClick={this.toggleSidebar}
                      >
                        <i className="fa fa-times" aria-hidden="true" />
                      </Button>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Form onSubmit={this.handleSubmit} className="filter-form">
                      <Row>
                        <Col md="12">
                          <div className="mb-2">
                            <label className="fancy-checkbox" htmlFor="includeChildrenCheckbox">
                              <input
                                type="checkbox"
                                name="includeChildren"
                                checked={filters.includeChildren || false}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  this.setState(
                                    (prevState) => {
                                      const newFilters = {
                                        ...prevState.filters,
                                        includeChildren: checked,
                                        child_domain: checked
                                          ? ALL_CHILD_DOMAIN
                                          : prevState.lastSelectedChildDomain || prevState.parentDomain || prevState.filters.child_domain,
                                        meter: "-Combine Together-", // ✅ Reset meter selection
                                      };
                                      return {
                                        filters: {
                                          ...newFilters,
                                          childcheckbox: checked,
                                        },
                                        lastSelectedChildDomain: checked ? prevState.filters.child_domain : prevState.lastSelectedChildDomain,
                                      };
                                    },
                                    () => {
                                      this.fetchMeterNames();
                                    },
                                  );
                                }}
                                className="custom-control-input"
                                id="includeChildrenCheckbox"
                              />
                              <span>
                                <i />
                                Include Children Sites
                              </span>
                            </label>
                          </div>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <PropertDetails selectedPropertyObj={this.state.selectedPropertyObj} changeProperty={this.changeProperty} hideLabel />
                          </Form.Group>
                        </Col>
                        {/* 
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Select Lot:</Form.Label>
                            <Form.Control
                              as="select"
                              name="lot_id"
                              value={this.state.lot_id}
                              onChange={this.handleChange}
                              disabled={this.state.ticketReportLots?.length < 1 || this.state.childcheckbox}
                              placeholder="Select Lot"
                            >
                              {this.state.ticketReportLots?.length ? (
                                <>
                                  <option value="">All Lots</option>
                                  {this.state.ticketReportLots.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.alias}
                                    </option>
                                  ))}
                                </>
                              ) : null}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        */}
                        <Col md="12">
                          <Form.Group>
                            <Row>
                              <Col xs={6} style={{ paddingRight: "8px" }}>
                                <Form.Label style={{ fontSize: "14px", fontWeight: 500 }}>From:</Form.Label>
                                <DatePicker
                                  className="form-control"
                                  selected={moment(filters.from_date, "YYYY-MM-DD").toDate()}
                                  onChange={(date) => {
                                    const newFromDate = moment(date);
                                    const currentToDate = moment(this.state.filters.to_date, "YYYY-MM-DD");

                                    // If from date is after to date, force to_date = from_date
                                    let useToDate = currentToDate;
                                    if (newFromDate.isAfter(currentToDate)) {
                                      useToDate = newFromDate.clone();
                                    }

                                    // If from → to is more than 90 days, cap it
                                    const maxAllowedToDate = newFromDate.clone().add(90, "days");
                                    if (useToDate.diff(newFromDate, "days") > 90) {
                                      useToDate = maxAllowedToDate;
                                    }

                                    const today = moment().startOf("day"); // << Force day only
                                    const cappedFromDate = newFromDate.isAfter(today) ? today : newFromDate;
                                    const cappedToDate = useToDate.isAfter(today) ? today : useToDate;

                                    this.setState((prevState) => ({
                                      filters: {
                                        ...prevState.filters,
                                        from_date: cappedFromDate.format("YYYY-MM-DD"),
                                        to_date: cappedToDate.format("YYYY-MM-DD"),
                                      },
                                    }));
                                  }}
                                  dateFormat="MM/dd/yyyy"
                                  placeholderText="Start Date"
                                  maxDate={moment().endOf("day").toDate()} // ✅ Ensures no future pick
                                />
                              </Col>
                              <Col xs={6} style={{ paddingLeft: "8px" }}>
                                <Form.Label style={{ fontSize: "14px", fontWeight: 500 }}>To:</Form.Label>
                                <DatePicker
                                  className="form-control"
                                  selected={moment(filters.to_date, "YYYY-MM-DD").toDate()}
                                  onChange={(date) => {
                                    const newToDate = moment(date);
                                    const currentFromDate = moment(this.state.filters.from_date, "YYYY-MM-DD");
                                    const today = moment();
                                    const cappedToDate = newToDate.isAfter(today) ? today : newToDate;

                                    this.setState((prevState) => ({
                                      filters: {
                                        ...prevState.filters,
                                        to_date: cappedToDate.format("YYYY-MM-DD"),
                                      },
                                    }));
                                  }}
                                  minDate={moment(filters.from_date, "YYYY-MM-DD").toDate()}
                                  maxDate={moment
                                    .min(
                                      moment(filters.from_date, "YYYY-MM-DD").add(90, "days"),
                                      moment(), // today's date
                                    )
                                    .toDate()} // <== This caps max to either 90 days from from_date or today
                                  dateFormat="MM/dd/yyyy"
                                  placeholderText="End Date"
                                />
                              </Col>
                            </Row>
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Time Resolution:</Form.Label>
                            <Form.Control as="select" name="time_resolution" value={filters.time_resolution} onChange={this.handleChange}>
                              <option value="Day">Day</option>
                              <option value="Week">Week</option>
                              <option value="Month">Month</option>
                              <option value="Year">Year</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Meter:</Form.Label>
                            <Form.Control
                              as="select"
                              name="meter"
                              value={filters.meter}
                              onChange={this.handleChange}
                              disabled={meterOptions.length <= 1 || filters.includeChildren} // ✅ Only "All Meters" exists → disable
                            >
                              {meterOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Transaction Type:</Form.Label>
                            <Form.Control as="select" name="type" value={filters.type} onChange={this.handleChange}>
                              <option value="Paid and Refunds">Paid and Refunds</option>
                              <option value="Paid">Paid</option>
                              <option value="Refunded">Refunded</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Show:</Form.Label>
                            <div className="d-flex flex-column flex-md-row">
                              <Form.Check
                                custom
                                className="mr-md-3 mb-2 mb-md-0"
                                type="checkbox"
                                id="show-value"
                                label="Sum"
                                name="show"
                                value="Value"
                                checked={filters.show.includes("Value")}
                                onChange={this.handleChange}
                              />
                              <Form.Check
                                custom
                                className="mr-md-3"
                                type="checkbox"
                                id="show-count"
                                label="Count"
                                name="show"
                                value="Count"
                                checked={filters.show.includes("Count")}
                                onChange={this.handleChange}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Output:</Form.Label>
                            <Form.Control as="select" name="output" value={filters.output} onChange={this.handleChange}>
                              {OUTPUT_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Display As:</Form.Label>
                            <Form.Control as="select" name="display_as" value={filters.display_as} onChange={this.handleChange}>
                              <option value="Value">Value</option>
                              <option value="Percentage">Percentage</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Payment Method Resolution:</Form.Label>
                            <Form.Control as="select" name="payment_method" value={filters.payment_method} onChange={this.handleChange}>
                              <option value="Detailed">Detailed</option>
                              <option value="CashVsCard">Cash vs Card</option>
                              <option value="CreditVsDebit">Credit vs Debit</option>
                              <option value="OnlineVsAtMeter">Online vs At Meter</option>
                              <option value="Combined">Combined</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                  <Card.Footer className="text-right d-flex justify-content-between">
                    <Button variant="info" className="h-40 custom-btn-secondary btn-sm" onClick={this.handleReset} disabled={loading}>
                      Reset
                    </Button>
                    <Button variant="info" className="h-40 btn-fill btn-sm ml-2" onClick={this.handleSubmit} disabled={loading}>
                      Search
                    </Button>
                  </Card.Footer>
                </Card>
              </div>
            )}
            <div className="output-wrapper">
              {fallbackMessage && (
                <div className="alert alert-warning mb-3" role="alert">
                  {fallbackMessage}
                </div>
              )}
              {appliedFilters.output === "table" && filteredTableData.length > 0 ? (
                <div
                  className="citation-list-table list-of-ravenue-table has-parent-tab revenue-report-table"
                  style={{
                    maxHeight: this.state.isExpandedView ? "none" : undefined,
                    overflow: this.state.isExpandedView ? "visible" : undefined,
                  }}
                >
                  <DataTable
                    columns={headers
                      .map((header, idx) => ({ header, idx }))
                      .filter(({ header }) => {
                        const resolution = appliedFilters?.time_resolution;
                        const typeFilter = appliedFilters?.type;
                        return !(header === "Type" && (resolution === "Year" || resolution === "Week") && typeFilter !== "Paid and Refunds");
                      })
                      .map(({ header, idx }) => ({
                        name: <div style={{ whiteSpace: "nowrap", minWidth: "100px" }}>{header}</div>,
                        selector: (row) => {
                          const value = row[idx];

                          // ✅ Handle date column (first column)
                          if (idx === 0) {
                            const raw = row.rawDate || row[idx];
                            const res = appliedFilters?.time_resolution;

                            if (res === "Month") {
                              const parsed = moment(raw, ["YYYY-MM"]);
                              return parsed.isValid() ? parsed.format("MMMM YYYY") : raw;
                            }

                            if (res === "Year") {
                              return raw;
                            }

                            return raw; // Day-level or fallback
                          }

                          // ✅ Handle "Type" and "Meter" columns as strings
                          if (header === "Type" || header === "Meter") {
                            return typeof value === "string" ? value.toLowerCase() : value;
                          }
                          if (header === "Domain") {
                            return typeof value === "string" ? value.toLowerCase() : value || "";
                          }

                          // ✅ Handle percentage strings
                          // ✅ Handle "Percentage" mode properly
                          if (appliedFilters.display_as === "Percentage" && !header.toLowerCase().includes("total")) {
                            const isDollar = header.includes("$");
                            const isCount = header.includes("#");

                            if (isDollar || isCount) {
                              const relevantIndices = headers
                                .map((h, i) => ({ h, i }))
                                .filter(({ h }) =>
                                  isDollar ? h.includes("$") && !h.toLowerCase().includes("total") : h.includes("#") && !h.toLowerCase().includes("total"),
                                )
                                .map(({ i }) => i);

                              const raw = parseFloat(row[idx]) || 0;
                              const rowTotal = relevantIndices.reduce((sum, i) => sum + (parseFloat(row[i]) || 0), 0) || 1;
                              return (raw / rowTotal) * 100;
                            }
                          }

                          // ✅ Handle numeric values

                          const num = parseFloat(value);
                          return Number.isNaN(num) ? 0 : num;
                        },
                        format: (row) => {
                          const value = row[idx];
                          if (header === "Domain") return value || "Unknown";
                          const isCount = header.includes("#");
                          const isTotalDollar = header.toLowerCase().includes("total") && header.includes("$");
                          const isDollar = header.includes("$") && !isTotalDollar;

                          if (header === "Type") return value || "Unknown";
                          if (idx === 0) {
                            const raw = row.rawDate || row[idx];
                            const cleanDate = typeof raw === "string" ? raw.split("T")[0] : raw;
                            const date = moment(cleanDate, "YYYY-MM-DD");

                            if (!date.isValid()) return raw;

                            const res = appliedFilters?.time_resolution;
                            if (res === "Year") return cleanDate;
                            if (res === "Month") return date.format("MMMM YYYY");
                            if (res === "Week") return row[idx]?.replace(/^From:\s*/i, "") || row[idx];

                            return date.format("YYYY-MM-DD");
                          }
                          if (header === "Meter") return this.getMeterLabel(row[idx]);
                          const raw = parseFloat(row[idx]) || 0;

                          if (appliedFilters.display_as === "Percentage" && !isTotalDollar && !isCount) {
                            const relevantIndices = headers
                              .map((h, i) => ({ h, i }))
                              .filter(({ h }) =>
                                isDollar
                                  ? h.includes("$") && !h.toLowerCase().includes("total")
                                  : isCount
                                  ? h.includes("#") && !h.toLowerCase().includes("total")
                                  : false,
                              )
                              .map(({ i }) => i);

                            const rowTotal = relevantIndices.reduce((sum, i) => sum + (parseFloat(row[i]) || 0), 0) || 1;
                            return `${((raw / rowTotal) * 100).toFixed(2)}%`;
                          }

                          return isCount ? raw.toLocaleString() : this.formatCurrency(raw);
                        },
                        sortable: true,
                        wrap: false,
                      }))}
                    data={filteredTableData}
                    paginationPerPage={30}
                    dense
                    fixedHeader={!this.state.isExpandedView}
                    fixedHeaderScrollHeight={!this.state.isExpandedView ? "500px" : undefined}
                    highlightOnHover
                    responsive
                    expandableRows={false}
                  />
                  <div className="mt-3 px-4" style={{ fontSize: "15px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <strong style={{ minWidth: "90px" }}>Duration:</strong>
                      <span style={{ fontWeight: 500 }}>
                        {isYearly
                          ? `${moment(appliedFilters.from_date, "YYYY-MM-DD").startOf("year").format("YYYY-MM-DD")} to ${moment(
                              appliedFilters.to_date,
                              "YYYY-MM-DD",
                            )
                              .endOf("year")
                              .format("YYYY-MM-DD")}`
                          : isMonthly
                          ? (() => {
                              const start = moment(appliedFilters.from_date, "YYYY-MM-DD").startOf("month");
                              const end = moment(appliedFilters.to_date, "YYYY-MM-DD").endOf("month");
                              return `${start.format("YYYY-MM-DD")} to ${end.format("YYYY-MM-DD")}`;
                            })()
                          : `${moment(appliedFilters.from_date, "YYYY-MM-DD").format("YYYY-MM-DD")} to ${moment(appliedFilters.to_date, "YYYY-MM-DD").format(
                              "YYYY-MM-DD",
                            )}`}
                      </span>
                    </div>
                    <div className="table-footer pt-3 pb-4">
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "15px" }}>
                        {columnTotals
                          .filter((col) => col.label !== "Type" && col.label !== "Meter" && col.label !== "Domain")
                          .map((col) => {
                            const isCount = col.label.includes("#");
                            const formatted = isCount ? col.total.toLocaleString() : this.formatCurrency(col.total);
                            const isTotalRow = col.label.toLowerCase().startsWith("total");

                            return (
                              <div
                                key={col.label}
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  gap: "40px",
                                  fontSize: "15px",
                                }}
                              >
                                <strong style={{ minWidth: "150px" }}>{col.label}:</strong>
                                <span style={{ fontWeight: isTotalRow ? "bold" : "normal" }}>{formatted}</span>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              ) : appliedFilters.output !== "table" && Array.isArray(chartData) && chartData.length > 1 ? (
                this.renderChart()
              ) : (
                <div>There are no records to display.</div>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

// Map Redux state to props
const mapStateToProps = (state) => ({
  auditDataMining: state.SuperAdminDetails.auditDataMiningList || [],
  getAllProperties: state.SuperAdminDetails.getAllProperties || [],
  lots: state.SuperAdminDetails.lots || [],
});

// Map dispatch to props
const mapDispatchToProps = {
  get_all_properties: SuperAdminAction.get_all_properties,
  get_all_lots: SuperAdminAction.get_all_lots,
  selected_Property: SuperAdminAction.selected_Property,
  getAuditDataMining,
  get_all_meters: SuperAdminAction.get_all_meters,
  exportAuditMiningPDF,
  exportAuditMiningXLS,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedRevenueReportData);
